import { jsx as o } from "react/jsx-runtime";
import "../../../ActionButton-B77eJAd5.js";
import "styled-components";
import "react";
import "../../../styles/icons/icons.js";
import "../../layout/Stack/Stack.js";
import "../../layout/Box/Box.js";
import "../../../index-CZ8zjHGv.js";
import "../../layout/Center/Center.js";
import "../../../context/WindowSize/Dimensions.js";
import "lodash-es";
import "../../layout/Columns/ColumnsContext.js";
import "../../typography/Text/Text.js";
import "../../../context/Text.js";
import "../../../context/Typography.js";
import "../../../hooks/link/index.js";
import "focus-trap-react";
import "@material/material-color-utilities";
import "../../content/Logo/consts.js";
import d from "../../controls/TextInput/TextInput.js";
import "react-select";
import "react-select/async";
import "../../controls/Toggle/CustomCheckbox.js";
import s from "../FieldError/FieldError.js";
import n from "../FieldLabel/FieldLabel.js";
import f from "../FieldLayout/FieldLayout.js";
function J(t) {
  const {
    name: r,
    label: e,
    error: p,
    dataTest: a,
    showError: m = !1,
    ...l
  } = t, i = u(a);
  return /* @__PURE__ */ o(f, { showError: m, children: {
    label: /* @__PURE__ */ o(n, { htmlFor: r, dataTest: i("label"), children: e }),
    field: /* @__PURE__ */ o(
      d,
      {
        id: r,
        name: r,
        error: m,
        dataTest: i("field"),
        ...l
      }
    ),
    error: /* @__PURE__ */ o(s, { dataTest: i("error"), children: p })
  } });
}
const u = (t) => (r) => t ? `${t}-${r}` : void 0;
export {
  J as default
};
